export default {
  title: 'Gracias por enviar tu información para recibir pagos',
  description:
    'La revisión de Stripe puede tardar hasta 48 horas. Mientras tanto, puedes continuar con los siguientes pasos. Te informaremos por correo electrónico en cuanto tu información sea confirmada.',
};
